var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenDotWatchIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.028,
    viewBox: "0 0 20 19.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-133 -224)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h17.028v17.028H0z",
    transform: "translate(133 226)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21314b",
    d: "M13.372 4.525L14.4 3.494l1 1-1.025 1.034a6.386 6.386 0 1 1-1-1zm-3.986 9.956a4.967 4.967 0 1 0-4.967-4.967 4.967 4.967 0 0 0 4.967 4.967zm-.71-8.514H10.1v4.257H8.676zM6.548 1h5.676v1.419H6.548z",
    transform: "translate(133 226) translate(-0.872 -0.29)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#2bc48a",
    transform: "translate(148 224)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDotWatchIcon);
export default __webpack_public_path__ + "static/media/GreenDotWatchIcon.05edd1f6717b0c434d185880ac3128bc.svg";
export { ForwardRef as ReactComponent };